<div class="container d-flex flex-column px-3 px-md-0"
    *ngIf="tipoBusca !== 'carro' && tipoBusca !== 'revisa-orcamento'">
    <div class="col-12 d-flex align-items-center m-md-0 mb-4 px-md-0 px-3 justify-content-between">
        <h3 class="m-0">Refazer Busca</h3>
        <div class="m-0">
            <button class="btn btn-primary mb-md-3 m-0 w-md-100" type="button" data-bs-toggle="collapse"
                (click)="expandir()" data-bs-target="#accordionItem1" aria-expanded="true"
                aria-controls="accordionItem1">
                {{expandirAccordion ? "Fechar Refazer Busca" : "Expandir Refazer Busca"}}
            </button>
        </div>
    </div>

    <div class="accordion mb-4" id="myAccordion">
        <div class="accordion-item border-personal">
            <div id="accordionItem1" class="accordion-collapse collapse box-shadow show" aria-labelledby="headingOne"
                data-bs-parent="#myAccordion">
                <div class="accordion-body">
                    <div class="input-group" *ngFor="let trecho of busca.trechos; let i = index">
                        @if (tipoBusca === 'aereo' || i === 0 && !busca.tipoBusca.circuito) {
                        <div class="row w-100">
                            <!-- Origem -->
                            @if (tipoBusca === 'aereo'){
                            <div class="col-md-3 col-12 rebusca-linha">
                                <div class="buscaField">
                                    <label>{{ "Selecione a origem" | translate }}</label>
                                    <app-typeahead name="cidadeorigem" [lista]="cidades"
                                        [searchText]="trecho.AeroportoPartida.display_field"
                                        (searchFunction)="buscaDados($event)"
                                        (selectItem)="selecionaCidadeOrigem($event, trecho)">
                                        <input class="theme-search-area-section-input" type="text"
                                            placeholder="{{'Origem' | translate}}" required
                                            [(ngModel)]="trecho.AeroportoPartida.display_field"
                                            (ngModelChange)="buscaCidadeDebounce($event)" />
                                    </app-typeahead>
                                </div>
                            </div>
                            }

                            <!-- Destino -->
                            @if ((busca.tipoBusca.aereo || busca.tipoBusca.hotel || busca.tipoBusca.ticket ||
                            busca.tipoBusca.servicoExclusivo) && tipoBusca !== 'beto-carrero') {
                            <div class="col-md-3 col-12 rebusca-linha"
                                [ngClass]="{ 'col-md-4': tipoBusca !== 'aereo' }">
                                <div class="buscaField">
                                    <label>{{ "Selecione o destino" | translate }}</label>
                                    @if (tipoBusca === 'aereo') {
                                    <app-typeahead name="cidadedestino" [lista]="cidades"
                                        [searchText]="trecho.AeroportoChegada.display_field"
                                        (searchFunction)="buscaDados($event)"
                                        (selectItem)="selecionaCidadeDestino($event, trecho)">
                                        <input class="form-control theme-search-area-section-input" type="text"
                                            placeholder="{{'Destino' | translate}}" required
                                            [(ngModel)]="trecho.AeroportoChegada.display_field"
                                            (ngModelChange)="buscaCidadeDebounce($event)" autocomplete="off" />
                                    </app-typeahead>
                                    } @else {
                                    <app-typeahead name="cidadedestino" [lista]="cidades"
                                        [searchText]="trecho.cidadeDestino.display_field"
                                        (searchFunction)="buscaCidade($event)"
                                        (selectItem)="selecionaCidadeDestino($event, trecho)">
                                        <input class="form-control theme-search-area-section-input" name="cidadeDestino"
                                            placeholder="{{ 'Cidade' | translate }}"
                                            (ngModelChange)="buscaCidadeDebounce($event)"
                                            [(ngModel)]="trecho.cidadeDestino.display_field" autocomplete="off" />
                                    </app-typeahead>
                                    }
                                </div>
                            </div>
                            }

                            <!-- Data de Partida -->
                            @if((busca.tipoBusca.aereo || busca.tipoBusca.hotel || busca.tipoBusca.ticket ||
                            busca.tipoBusca.servicoExclusivo) && tipoBusca !== 'beto-carrero') {
                            <div class="col-3 mt-2 rebusca-linha">
                                <mat-form-field class="datepicker" appearance="fill">
                                    <mat-label>
                                        {{ tipoBusca === 'aereo' ?
                                        "Data de Partida" : ("Data Check-in" | translate) }}
                                    </mat-label>
                                    <input matInput [matDatepicker]="picker" [(ngModel)]="trecho.dataIda" name="dataIda"
                                        (dateChange)="setDataIdaRebusca($event, busca.trechos, i)" [min]="trecho.minDataIda"
                                        id="dataIda" (keypress)="permitirSomenteDatas($event)"
                                        (input)="formatarDataManual($event)" (keydown)="limpar($event)" maxlength="10"
                                        maxlength="10" required autocomplete="off" />
                                    <mat-datepicker #picker></mat-datepicker>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                </mat-form-field>
                            </div>
                            }

                            <!-- Data de Volta -->
                            @if ((busca.tipoBusca.aereo || busca.tipoBusca.hotel || busca.tipoBusca.ticket ||
                            busca.tipoBusca.servicoExclusivo) &&
                            (busca.tipoBuscaAereo !== TIPOBUSCAAEREO.ida || tipoBusca !== 'aereo') &&
                            (busca.tipoBuscaAereo !== TIPOBUSCAAEREO.multiplosTrechos || tipoBusca !== 'aereo') &&
                            tipoBusca !== 'beto-carrero') {
                            <div class="col-md-3 col-12 mt-2 align-items-center d-flex rebusca-linha">
                                <mat-form-field class="datepicker" appearance="fill">
                                    <mat-label>{{ aereo ? "Data de Volta" : ("Data Check-out" | translate)
                                        }}</mat-label>
                                    <input matInput [matDatepicker]="pickerVolta" [(ngModel)]="trecho.dataVolta"
                                        name="dataVolta" (dateChange)="setDataVoltaRebusca($event, busca.trechos, i)"
                                        [min]="trecho.minDataVolta" id="inputVolta" required
                                        (keypress)="permitirSomenteDatas($event)" (input)="formatarDataManual($event)"
                                        (keydown)="limpar($event)" maxlength="10" />
                                    <mat-datepicker-toggle matSuffix [for]="pickerVolta"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerVolta></mat-datepicker>
                                </mat-form-field>
                            </div>
                            }

                            <!-- Hora de Retirada -->
                            @if (!(tipoBusca === 'aereo' || tipoBusca === 'hotel' || tipoBusca === 'ticket' || tipoBusca === 'servicoExclusivo' || tipoBusca === 'beto' || tipoBusca === 'circuito') && busca.tipoBusca.carro) {
                            <div class="col-md-2 col-12 mt-2 rebusca-linha"
                                style="margin-right: 0.5rem !important; margin-left: 2.25rem !important;">
                                <mat-form-field class="datepicker" appearance="fill">
                                    <mat-label>{{ "Hora Retirada" | translate }}</mat-label>
                                    <input matInput [(ngModel)]="busca.horaOrigem" type="time" required />
                                </mat-form-field>
                            </div>

                            <!-- Hora de Devolução -->
                            <div class="col-md-2 col-12 mt-2 rebusca-linha"
                                style="margin-right: 0.5rem !important; margin-left: 2.25rem !important;">
                                <mat-form-field class="datepicker" appearance="fill">
                                    <mat-label>{{ "Hora Devolução" | translate }}</mat-label>
                                    <input matInput [(ngModel)]="busca.horaDevolucao" type="time" required />
                                </mat-form-field>
                            </div>
                            }

                            <!-- Data de Visita -->
                            @if(busca.tipoBusca.beto && tipoBusca === 'beto-carrero') {
                            <div class="col-4 mt-2 rebusca-linha">
                                <mat-form-field class="datepicker" appearance="fill">
                                    <mat-label class="label-datepicker">{{"Data de visita" | translate }}</mat-label>
                                    <input matInput [matDatepicker]="pickerVisita"
                                        [(ngModel)]="busca.dataVisitaBetoCarrero" name="visita" id="visita"
                                        [min]="trecho.dataIda" [max]="trecho.dataVolta"
                                        (keypress)="permitirSomenteDatas($event)"
                                        (input)="formatarDataManual($event)" (keydown)="limpar($event)"
                                        maxlength="10" required />
                                    <mat-datepicker-toggle matSuffix
                                        [for]="pickerVisita"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerVisita></mat-datepicker>
                                </mat-form-field>
                            </div>
                            }
                        </div>
                        }
                    </div>

                    <!-- CIRCUITO -->
                    @if (!(tipoBusca === 'aereo' || tipoBusca === 'hotel' || tipoBusca === 'ticket' || tipoBusca === 'servicoExclusivo' || tipoBusca === 'beto' || tipoBusca === 'carro') && busca.tipoBusca.circuito) {
                    <div class="col-md-12 row d-flex flex-row rebusca-linha">
                        <div class="col-md-3">
                            <label class="mb-1" style="color: #808080;">Temporada</label>
                            <select [(ngModel)]="busca.Temporada" class="form-control pb-3 pt-3" style="margin-right: 15px;" name="inputTemporada">
                                <option *ngFor="let temporada of Temporadas" [value]="temporada">
                                    {{temporada +" - "+ addOneYear(temporada)}}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-3 d-flex flex-row">
                            <div class="d-flex form-control justify-content-center" style="margin-left: 15px; margin-right: 15px;"
                                *ngFor="let circuitoFornecedor of Fornecedores; let i = index;">
                                <div class="align-self-center text-center">
                                    <input type="checkbox" id="circuito-{{circuitoFornecedor}}" style="width: 21px; height: 21px;"
                                        name="circuito-{{circuitoFornecedor}}" (change)="selecionarCircuito(circuitoFornecedor)"
                                        [checked]="circuitoSelecionado(circuitoFornecedor)" />
                                </div>
                                <div class="align-self-center text-center">
                                    <label class="form-check-label" for="circuito-{{circuitoFornecedor}}">
                                        <img style="width: 200px; max-height: 200px; min-height: 0px !important;" src="assets/img/circuitos/{{circuitoFornecedor}}.png" />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    }

                    <div class="col-12 d-flex justify-content-between">
                        <button type="submit" (click)="voltar()" class="btn btn-outline-primary col-1 mt-4">
                            {{"Voltar" | translate}}
                        </button>
                        <button type="submit" (click)="buscou()" class="btn btn-search col-1 mt-4">
                            {{"Buscar" | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container d-flex flex-column" *ngIf="busca.tipoBusca.carro">
        <div class="d-flex gap-3 mb-3">
            <!-- Local de Retirada -->
            <div class="form-floating w-50">
                <app-typeahead class="form-floating" [tap]="false" name="LocalRetirada" [lista]="lojas"
                    [searchText]="busca.localOrigem.display_field" (searchFunction)="buscaLojas($event)"
                    (selectItem)="selecionaLojaOrigem($event)">
                    <input class="form-control" type="text" placeholder="{{'Origem' | translate}}"
                        [(ngModel)]="busca.localOrigem.display_field" (ngModelChange)="buscaLojasDebounce($event)"
                        autocomplete="new-password" />
                    <label for="floatingInput">{{"Local de Retirada" | translate}}</label>
                </app-typeahead>
            </div>

            <!-- Data de Ida -->
            <div class="form-floating">
                <input type="date" class="form-control" id="ida" onKeyDown="return false" [(ngModel)]="busca.dataOrigem"
                    (ngModelChange)="setDataOrigem($event)" [min]="minDate" />
                <label for="floatingInput">{{"Data de Ida" | translate}}</label>
            </div>

            <!-- Hora de Retirada -->
            <div class="form-floating w-25">
                <select class="form-control" name="horaOrigem" id="horaOrigem" [(ngModel)]="busca.horaOrigem">
                    <option value="0">00</option>
                    <option value="1">01</option>
                    <!-- outras opções -->
                </select>
                <label for="floatingInput">{{"Hora Retirada" | translate}}</label>
            </div>
        </div>

        <div class="d-flex gap-3 mb-1">
            <!-- Local de Devolução -->
            <div class="form-floating w-50">
                <app-typeahead class="form-floating" [tap]="false" name="LocalDevolucao" [lista]="lojas"
                    [searchText]="busca.localDevolucao.display_field" (searchFunction)="buscaLojas($event)"
                    (selectItem)="selecionaLojaDevolucao($event)">
                    <input class="form-control" type="text" placeholder="{{'Devolução' | translate}}"
                        [(ngModel)]="busca.localDevolucao.display_field" (ngModelChange)="buscaLojasDebounce($event)"
                        autocomplete="new-password" />
                    <label for="floatingInput">{{"Local de Devolução" | translate}}</label>
                </app-typeahead>
            </div>

            <!-- Data de Devolução -->
            <div class="form-floating">
                <input type="date" class="form-control" id="devolucao" onKeyDown="return false"
                    [(ngModel)]="busca.dataDevolucao" (ngModelChange)="setDataDevolucao($event)"
                    [min]="busca.dataOrigem" />
                <label for="floatingInput">{{"Data de Devolução" | translate}}</label>
            </div>

            <!-- Hora de Devolução -->
            <div class="form-floating w-25">
                <select class="form-control" name="horaDevolucao" id="horaDevolucao" [(ngModel)]="busca.horaDevolucao">
                    <option value="0">00</option>
                    <option value="1">01</option>
                    <!-- outras opções -->
                </select>
                <label for="floatingInput">{{"Hora Devolução" | translate}}</label>
            </div>
        </div>

        <div class="mb-4">
            <div class="col-2 ms-auto">
                <button type="submit" (click)="buscou()" class="btn btn-search col-2 mt-4">
                    <i class="fas fa-arrow-right"></i>
                </button>
            </div>
        </div>
    </div>
</div>